module.exports = __webpack_public_path__ + "4e944913f330a79aebcff03615b4acf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Slideshow/Control/right.png
// module id = ./src/components/Slideshow/Control/right.png
// module chunks = 0